import { useRouterState } from '@tanstack/react-router';
import { useLocalStorage } from 'usehooks-ts';
import { CONTROL_BAR_CLEARANCE_CLASS } from './carePlanControlStyles';
import { pointerCanReachBar } from './controlBarReach';
import { CONTROL_BAR_HIDDEN_STORAGE_KEY } from './controlBarHiddenKey';

/**
 * Room for the control bar, and nothing once it is hidden. Views go through the hook rather than the
 * constant so the two cannot drift apart — including the case where the bar stays out despite the
 * preference, because the pointer could not bring it back on this view (`controlBarReach`).
 */
export const useControlBarClearance = (): string => {
  const [controlBarHidden] = useLocalStorage(CONTROL_BAR_HIDDEN_STORAGE_KEY, false);
  const pointerReaches = useRouterState({ select: (state) => pointerCanReachBar(state.location.pathname) });
  return controlBarHidden && pointerReaches ? '' : CONTROL_BAR_CLEARANCE_CLASS;
};
